// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vk3N2","colBig":"styles_colBig__aPZA1","colSmall":"styles_colSmall__1rouc","shopifyNameWrapper":"styles_shopifyNameWrapper__cI_aJ"};